<script>
    import { clientPurchaseCancel } from '../clients/PurchaseClient.svelte';
    import { store } from '../Store.svelte';
    import { navigate } from 'svelte-routing';
    import { onMount } from 'svelte';

    export let ident = '';
    export let title = '';
    export let message = '';
    export let customAction = () => {};
    let url = '';
    $: isSky = $store.requestedServices?.isSky;

    onMount(() => (url = window.location.href));

    function getModalContent(message) {
        if (message === '¿Deseas iniciar la contratación?') {
            return {
                content: `Comenzaremos la contratación del servicio ${isSky ? 'Sky' : 'izzi'} que elegiste. <br />Solo te tomará unos minutos.`,
                type: 'start-contract',
            };
        }
        if (
            message.includes('Debes ingresar al menos un numero celular valido')
        ) {
            return {
                content: `El número celular ingresado no es válido. Por favor inténtalo con un número diferente o comunícate con nuestros asesores.`,
                type: 'invalid-cell',
            };
        }
        if (message === 'Codigo no valido') {
            return {
                content: `El código ingresado no es válido. Por favor verifica el código o comunícate con nuestros asesores.`,
                type: 'invalid-code',
            };
        }
        if (message.includes('El horario de instalación seleccionado')) {
            return {
                content: `El horario de instalación seleccionado no está disponible. Por favor selecciona otro horario.`,
                type: 'internal-error',
            };
        }
        if (message.includes('Respuesta no recibida')) {
            return {
                content: `Aún no recibimos tu respuesta, espera un momento e intenta nuevamente.`,
                type: 'processing-error',
            };
        }
        if (message.includes('Advertencia')) {
            return {
                content: `Has rechazado la compra. Si deseas continuar selecciona de nuevo el paquete que deseas.`,
                type: 'processing-error',
            };
        }
        return {
            content: `Ocurrió un error técnico al realizar tu contratación. Por favor inténtalo más tarde o comunícate con nuestros asesores.`,
            type: 'technical-error',
        };
    }

    function cancelOrder() {
        clientPurchaseCancel($store, url)
            .then(() => {
                const { product } = $store.requestedServices;
                if (product?.productFamily?.includes('izzinegocios')) {
                    navigate('/comparador/negocios');
                } else {
                    navigate('/comparador');
                }
            })
            .catch(console.log);
    }
</script>

<div class="modal" id={ident} aria-hidden="true">
    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div
            class="modal__container {getModalContent(message).type ===
            'start-contract'
                ? 'modal__container--medium'
                : ''}"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
        >
            <div class="modal__header" role="banner">
                <h2
                    class="modal__title text-fs-23 fw-semibold"
                    id="modal-title"
                >
                    {title}
                </h2>
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                ></button>
            </div>
            <div
                class="modal__content {getModalContent(message).type ===
                'start-contract'
                    ? 'm-b-20'
                    : 'm-b-10'}"
                role="main"
            >
                <p class="m-b-20">
                    {@html getModalContent(message).content}
                </p>
            </div>

            {#if getModalContent(message).type === 'start-contract'}
                <div class="modal__footer" role="contentinfo">
                    <div
                        class="d-flex align-items-center justify-content-end flex-wrap"
                    >
                        <p class="m-b-0 fw-semibold">
                            <a
                                href="#/"
                                class="primary-text"
                                class:blue-dark-text={isSky}
                                data-micromodal-close
                                on:click={cancelOrder}>En otro momento</a
                            >
                        </p>
                        <button
                            class="pure__button {isSky
                                ? 'pure__button--blue-dark'
                                : 'pure__button--base'}"
                            on:click={customAction}
                        >
                            Comenzar
                        </button>
                    </div>
                </div>
            {:else}
                <div class="modal__footer" role="contentinfo">
                    <button
                        class="pure__button {isSky
                            ? 'pure__button--blue-dark'
                            : 'pure__button--base'}"
                        data-micromodal-close
                        aria-label="Cerrar esta modal"
                        on:click={customAction}
                    >
                        Enterado
                    </button>
                </div>
            {/if}
        </div>
    </div>
</div>
